import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { ApiStatusCode, AppConstant } from '@app/shared/constants';
import { Pattern } from '@app/shared/validators/pattern';
import { Bug } from '../../models/bug';
import { BugService } from '../../services/bug/bug.service';

@Component({
  selector: 'app-report-bug',
  templateUrl: './report-bug.component.html',
  styleUrls: ['./report-bug.component.css']
})
export class ReportBugComponent implements OnInit {

  reportBugForm: FormGroup;
  userId: number;
  images = [];

  constructor(
    private formBuilder: FormBuilder,
    private loader: LoaderService,
    private notificationService: NotificationService,
    private bugService: BugService
  ) {
    this.userId = Number(localStorage.getItem('userId'));
    this.reportBugForm = this.formBuilder.group({
      title: new FormControl('', Validators.compose([Validators.required])),
      description: new FormControl('', Validators.compose([Validators.required])),
      stepsToReproduce: new FormControl('', Validators.compose([Validators.required])),
      file: new FormControl(''),
      fileSource: new FormControl(''),
      pageUrl: new FormControl('', Validators.compose([Validators.required, Validators.pattern(Pattern.LINK_PATTERN)]))
    })
  }

  ngOnInit() {
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.reportBugForm.controls;
  }

  onFileChange(event) {
    if (event.target.files && event.target.files[0]) {
      var filesAmount = event.target.files.length;
      for (let i = 0; i < filesAmount; i++) {
        var reader = new FileReader();

        reader.onload = (event: any) => {
          this.images.push(event.target.result);

          this.reportBugForm.patchValue({
            fileSource: this.images
          });
        }

        reader.readAsDataURL(event.target.files[i]);
      }
    }
  }

  fn_SubmitBug(formDirective: FormGroupDirective) {
    let value = this.reportBugForm.value;
    let data: Bug = {
      Title: value.title,
      Description: value.description,
      StepsToReproduce: value.stepsToReproduce,
      Files: value.fileSource,
      PageUrl: value.pageUrl,
      UserId: this.userId
    };
    this.loader.show();
    this.bugService.SubmitBug(data)
      .subscribe((res: any) => {
        if (res.StatusCode == ApiStatusCode.SUCCESS) {
          formDirective.resetForm();
          this.reportBugForm.reset();
          this.images = [];
          this.notificationService.success('Dear User, Thanks for reporting the bug, our team will work to resolve it as soon as possible.', 'Bug Reported');
        } else if (res.StatusCode === ApiStatusCode.BADREQUEST) {
          this.notificationService.error(res.Message, 'Try again');
        } else if (res.StatusCode === ApiStatusCode.INTERNAL_SERVER_ERROR) {
          this.notificationService.error('An error occured', 'Try again');
        }
        this.loader.hide();
      }, err => {
        console.error(err);
        this.notificationService.error(err.message, 'Error');
        this.loader.hide();
      });
  }

}
